import { defineStore } from 'pinia'

const INVITE_CODE_KEY = 'ydppt_invite_code'

const pickCodeFromParams = (params: URLSearchParams) => {
  return params.get('code') || params.get('inviteCode') || ''
}

const getStoredInviteCode = () => {
  return localStorage.getItem(INVITE_CODE_KEY) || ''
}

const getInviteCodeFromUrl = () => {
  const searchCode = pickCodeFromParams(new URLSearchParams(window.location.search))
  if (searchCode) return searchCode

  const hashQuery = window.location.hash.split('?')[1] || ''
  return pickCodeFromParams(new URLSearchParams(hashQuery))
}

const normalizeInviteCode = (code: unknown) => {
  if (Array.isArray(code)) return String(code[0] || '').trim()
  if (code == null) return ''
  return String(code).trim()
}

const buildInviteWebsiteUrl = (inviteCode: string) => {
  if (!inviteCode) return ''
  const url = new URL('/', window.location.origin)
  url.searchParams.set('code', inviteCode)
  return url.toString()
}

interface InviteStoreState {
  inviteCode: string
}

interface InviteStoreGetters {
  getInviteCode: string
  getInviteWebsiteUrl: string
}

interface InviteStoreActions {
  setInviteCode(code: string): void
  cacheInviteCodeFromCurrentUrl(extraCode?: unknown): void
  clearInviteCode(): void
}

export const useInviteStore = defineStore<'invite', InviteStoreState, InviteStoreGetters, InviteStoreActions>('invite', {
  state: (): InviteStoreState => ({
    inviteCode: getStoredInviteCode(),
  }),
  getters: {
    getInviteCode(): string {
      return this.inviteCode
    },
    getInviteWebsiteUrl(): string {
      return buildInviteWebsiteUrl(this.inviteCode)
    },
  },
  actions: {
    setInviteCode(code: string) {
      const normalized = normalizeInviteCode(code)
      if (!normalized) return
      this.inviteCode = normalized
      localStorage.setItem(INVITE_CODE_KEY, normalized)
    },
    cacheInviteCodeFromCurrentUrl(extraCode?: unknown) {
      this.setInviteCode(normalizeInviteCode(extraCode) || getInviteCodeFromUrl())
    },
    clearInviteCode() {
      this.inviteCode = ''
      localStorage.removeItem(INVITE_CODE_KEY)
    },
  },
})
